export default a => a === undefined;